import { render, staticRenderFns } from "./officeInvoiceConfig.vue?vue&type=template&id=51cc96c0&"
import script from "./officeInvoiceConfig.vue?vue&type=script&lang=js&"
export * from "./officeInvoiceConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cc96c0')) {
      api.createRecord('51cc96c0', component.options)
    } else {
      api.reload('51cc96c0', component.options)
    }
    module.hot.accept("./officeInvoiceConfig.vue?vue&type=template&id=51cc96c0&", function () {
      api.rerender('51cc96c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/role/officeInvoiceConfig.vue"
export default component.exports